import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=cc1a110e&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=cc1a110e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a110e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc1a110e')) {
      api.createRecord('cc1a110e', component.options)
    } else {
      api.reload('cc1a110e', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=cc1a110e&scoped=true&", function () {
      api.rerender('cc1a110e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FiNDHS0Pcbep/JS/comp/Voucher.vue"
export default component.exports